export default {
  FETCH_ALL_MENU_CATEGORIES_SUCCESS: 'FETCH_ALL_MENU_CATEGORIES_SUCCESS',
  FETCH_ALL_MENU_CATEGORIES_LOADING: 'FETCH_ALL_MENU_CATEGORIES_LOADING',
  FETCH_ALL_MENU_CATEGORIES_REJECT: 'FETCH_ALL_MENU_CATEGORIES_REJECT',
  FETCH_ALL_MENU_CATEGORIES_FAILED: 'FETCH_ALL_MENU_CATEGORIES_FAILED',


  CHANGE_MENU_CATEGORY_STATUS_SUCCESS: 'CHANGE_MENU_CATEGORY_STATUS_SUCCESS',
  CHANGE_MENU_CATEGORY_STATUS_LOADING: 'CHANGE_MENU_CATEGORY_STATUS_LOADING',
  CHANGE_MENU_CATEGORY_STATUS_REJECT: 'CHANGE_MENU_CATEGORY_STATUS_REJECT',
  CHANGE_MENU_CATEGORY_STATUS_FAILED: 'CHANGE_MENU_CATEGORY_STATUS_FAILED',

  FETCH_ALL_DELETED_MENU_CATEGORIES_SUCCESS: 'FETCH_ALL_DELETED_MENU_CATEGORIES_SUCCESS',
  FETCH_ALL_DELETED_MENU_CATEGORIES_LOADING: 'FETCH_ALL_DELETED_MENU_CATEGORIES_LOADING',
  FETCH_ALL_DELETED_MENU_CATEGORIES_REJECT: 'FETCH_ALL_DELETED_MENU_CATEGORIES_REJECT',
  FETCH_ALL_DELETED_MENU_CATEGORIES_FAILED: 'FETCH_ALL_DELETED_MENU_CATEGORIES_FAILED',

  DELETE_MENU_CATEGORY_SUCCESS: 'DELETE_MENU_CATEGORY_SUCCESS',
  DELETE_MENU_CATEGORY_LOADING: 'DELETE_MENU_CATEGORY_LOADING',
  DELETE_MENU_CATEGORY_REJECT: 'DELETE_MENU_CATEGORY_REJECT',
  DELETE_MENU_CATEGORY_FAILED: 'DELETE_MENU_CATEGORY_FAILED',

  FETCH_MENU_CATEGORY_BY_ID_SUCCESS: 'FETCH_MENU_CATEGORY_BY_ID_SUCCESS',
  FETCH_MENU_CATEGORY_BY_ID_LOADING: 'FETCH_MENU_CATEGORY_BY_ID_LOADING',
  FETCH_MENU_CATEGORY_BY_ID_REJECT: 'FETCH_MENU_CATEGORY_BY_ID_REJECT',
  FETCH_MENU_CATEGORY_BY_ID_FAILED: 'FETCH_MENU_CATEGORY_BY_ID_FAILED',


  INSERT_NEW_MENU_CATEGORY_SUCCESS: 'INSERT_NEW_MENU_CATEGORY_SUCCESS',
  INSERT_NEW_MENU_CATEGORY_LOADING: 'INSERT_NEW_MENU_CATEGORY_LOADING',
  INSERT_NEW_MENU_CATEGORY_REJECT: 'INSERT_NEW_MENU_CATEGORY_REJECT',
  INSERT_NEW_MENU_CATEGORY_FAILED: 'INSERT_NEW_MENU_CATEGORY_FAILED',


  UPDATE_MENU_CATEGORY_SUCCESS: 'UPDATE_MENU_CATEGORY_SUCCESS',
  UPDATE_MENU_CATEGORY_LOADING: 'UPDATE_MENU_CATEGORY_LOADING',
  UPDATE_MENU_CATEGORY_REJECT: 'UPDATE_MENU_CATEGORY_REJECT',
  UPDATE_MENU_CATEGORY_FAILED: 'UPDATE_MENU_CATEGORY_FAILED',

  EDIT_MENU_CATEGORY_SUCCESS: 'EDIT_MENU_CATEGORY_SUCCESS',
  EDIT_MENU_CATEGORY_LOADING: 'EDIT_MENU_CATEGORY_LOADING',
  EDIT_MENU_CATEGORY_REJECT: 'EDIT_MENU_CATEGORY_REJECT',
  EDIT_MENU_CATEGORY_FAILED: 'EDIT_MENU_CATEGORY_FAILED',

  FETCH_PRINTERS_SUCCESS: 'FETCH_PRINTERS_SUCCESS',
  FETCH_PRINTERS_LOADING: 'FETCH_PRINTERS_LOADING',
  FETCH_PRINTERS_REJECT: 'FETCH_PRINTERS_REJECT',
  FETCH_PRINTERS_FAILED: 'FETCH_PRINTERS_FAILED',
};
